import DonutChart from "./DonutChart.components"
import '../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/AppearanceInMeetings.style.css'
import CardHeader from "../../../../Universal/CardHeader.component";
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";

const AppearanceInMeetings = ({ donutChartData }) => {


    return (
        <div className="viewPollingDetailsContainer">
          <CardHeader
            title="Appearance in meetings"
            actionBtn={<SelectFilter />}
            headerStyle={{ borderBottom: "none" }}
          />
          <div className="flex-row g-05 space-between w-full h-half flex-1">
            <div className="h-full w-half">
              <DonutChart donutChartData={donutChartData} />
            </div>

            <div className="w-half h-full flex-col align-start justify-start">
              <ScrollableCardTable thead={["Participant", "Count", "%"]}>
                {donutChartData &&
                  donutChartData.map((_data, index) => {
                    return (
                      <tr
                        style={{
                          "--pollingDonutChartTableDetailsIndicatorColor":
                            _data.positionColor,
                        }}
                        className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                      >
                        <td
                          style={{
                            width: `calc(100%/${3})`,
                            textAlign: "center",
                          }}
                        >
                          {_data.participant}
                        </td>
                        <td
                          style={{
                            width: `calc(100%/${3})`,
                            textAlign: "center",
                          }}
                        >
                          {_data.appearanceCount}
                        </td>
                        <td
                          style={{
                            width: `calc(100%/${3})`,
                            textAlign: "center",
                          }}
                        >
                          {(
                            (_data.appearanceCount / _data.totalAttendee) *
                            100
                          ).toFixed(1)}{" "}
                          %
                        </td>
                      </tr>
                    );
                  })}
              </ScrollableCardTable>
            </div>
          </div>
        </div>
    )
}
export default AppearanceInMeetings